var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"banner"}),_c('div',{staticClass:"breadcrumbs"},[_c('span',[_vm._v("产品服务 > "+_vm._s(this.$route.meta.cnName))])]),_c('div',{staticClass:"contaner"},[_c('Menubar'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }